import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import {MailchimpRoutingModule} from "./mailchimp-routing.module";
import {EnlistComponent} from "./enlist/enlist.component";
import {PlatformModule} from "../platform/platform.module";
import {EnlistFormComponent} from "./enlist/enlist-form.component";


@NgModule({
  imports: [
    CommonModule,
    MailchimpRoutingModule,
    PlatformModule
  ],
  declarations: [EnlistComponent, EnlistFormComponent],
  providers: [],
  exports: [EnlistComponent, EnlistFormComponent]

})
export class MailchimpModule { }
